const { TextArea } = require("carbon-components-react")

const AdamTextArea = (props) => {
    return <TextArea {...props} />
}

export default AdamTextArea